import { styled, Tooltip, tooltipClasses } from '@mui/material';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip { ...props } classes={ { popper: className } }/>
))(({ theme }) => ({
    [`& .${ tooltipClasses.tooltip }`]: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        maxWidth: 220,
        paddingLeft: 15,
        paddingRight: 15,
        fontSize: theme.typography.pxToRem(12),
        border: `1px solid ${ theme.palette.divider }`,
        boxShadow: theme.shadows[2],
    },
}));

export default HtmlTooltip;
